/**
 * Cart Documento Tributario — Event delegation puro en document.
 * Cargado globalmente desde theme.liquid.
 * No depende de Custom Elements ni de timing de SPA/morph.
 */
(function() {
  'use strict';

  var CAMPOS_FACTURA = [
    { id: 'factura-rut', error: 'rut', validar: 'rut' },
    { id: 'factura-razon-social', error: 'razon-social', validar: 'texto' },
    { id: 'factura-giro', error: 'giro', validar: 'texto' }
  ];

  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }

  /* ===== Toggle Boleta / Factura ===== */
  function activarOpcion(opcion) {
    $$('.doc-tributario__opcion').forEach(function(o) {
      o.classList.remove('doc-tributario__opcion--active');
      o.setAttribute('aria-checked', 'false');
    });
    opcion.classList.add('doc-tributario__opcion--active');
    opcion.setAttribute('aria-checked', 'true');
    var radio = opcion.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    var campos = $('#factura-campos');
    var validacion = $('#validacion-global');
    var esFactura = opcion.dataset.opcion === 'Factura';

    if (campos) campos.style.display = esFactura ? 'grid' : 'none';
    limpiarErrores();
    if (validacion) validacion.style.display = 'none';
    if (!esFactura) limpiarCamposFactura();
  }

  /* ===== Click en opciones (delegado en document) ===== */
  document.addEventListener('click', function(e) {
    var opcion = e.target.closest('.doc-tributario__opcion');
    if (!opcion) return;
    activarOpcion(opcion);
  });

  /* ===== Formateo RUT + limpiar errores (delegado en document) ===== */
  document.addEventListener('input', function(e) {
    if (e.target.id === 'factura-rut') {
      var valor = e.target.value.replace(/[^0-9kK]/g, '');
      if (valor.length > 1) {
        var cuerpo = valor.slice(0, -1);
        var dv = valor.slice(-1).toUpperCase();
        cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        e.target.value = cuerpo + '-' + dv;
      }
    }
    if (e.target.closest('.doc-tributario__campo')) {
      e.target.classList.remove('doc-tributario__input-error');
      var campo = e.target.closest('.doc-tributario__campo');
      var err = campo ? campo.querySelector('.doc-tributario__error') : null;
      if (err) err.classList.remove('doc-tributario__error--visible');
    }
  });

  /* ===== Validación RUT chileno ===== */
  function validarRUT(rut) {
    if (!rut || rut.length < 3) return false;
    var limpio = rut.replace(/[.\-]/g, '');
    if (limpio.length < 2) return false;
    var cuerpo = limpio.slice(0, -1);
    var dv = limpio.slice(-1).toUpperCase();
    if (!/^\d+$/.test(cuerpo)) return false;
    var suma = 0, multiplo = 2;
    for (var i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo[i]) * multiplo;
      multiplo = multiplo === 7 ? 2 : multiplo + 1;
    }
    var dvEsperado = 11 - (suma % 11);
    if (dvEsperado === 11) dvEsperado = '0';
    else if (dvEsperado === 10) dvEsperado = 'K';
    else dvEsperado = dvEsperado.toString();
    return dv === dvEsperado;
  }

  function validarCamposFactura() {
    var valido = true;
    var container = $('#doc-tributario');
    if (!container) return true;
    CAMPOS_FACTURA.forEach(function(campo) {
      var input = document.getElementById(campo.id);
      var errorSpan = container.querySelector('[data-error="' + campo.error + '"]');
      if (!input) return;
      var invalido = campo.validar === 'rut'
        ? (!input.value.trim() || !validarRUT(input.value))
        : !input.value.trim();
      if (invalido) {
        input.classList.add('doc-tributario__input-error');
        if (errorSpan) errorSpan.classList.add('doc-tributario__error--visible');
        valido = false;
      }
    });
    return valido;
  }

  function limpiarErrores() {
    $$('.doc-tributario__input-error').forEach(function(e) {
      e.classList.remove('doc-tributario__input-error');
    });
    $$('.doc-tributario__error--visible').forEach(function(e) {
      e.classList.remove('doc-tributario__error--visible');
    });
  }

  function limpiarCamposFactura() {
    var campos = $('#factura-campos');
    if (campos) campos.querySelectorAll('input').forEach(function(i) { i.value = ''; });
  }

  /* ===== Interceptar checkout ===== */
  function interceptarCheckout(e) {
    var container = $('#doc-tributario');
    if (!container) return;
    var facturaRadio = container.querySelector('input[value="Factura"]');
    if (!facturaRadio || !facturaRadio.checked) return;

    limpiarErrores();
    var validacion = $('#validacion-global');
    if (validacion) validacion.style.display = 'none';

    if (!validarCamposFactura()) {
      e.preventDefault();
      e.stopPropagation();
      if (validacion) {
        validacion.style.display = 'flex';
        validacion.querySelector('span').textContent = 'Debes completar los datos de factura para continuar';
      }
      var primerError = container.querySelector('.doc-tributario__input-error');
      if (primerError) {
        primerError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        primerError.focus();
      }
      return false;
    }
  }

  document.addEventListener('submit', function(e) {
    if (e.target.id === 'cart-form' || e.target.closest('#cart-form')) {
      interceptarCheckout(e);
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#checkout, [name="checkout"], .cart__checkout-button, a[href="/checkout"]');
    if (btn) interceptarCheckout(e);
  });

  /* ===== Restaurar selección previa ===== */
  function restaurar() {
    var wrapper = document.querySelector('[data-doc-restore]');
    if (!wrapper || wrapper.dataset.docRestore !== 'Factura') return;
    var opcion = document.querySelector('[data-opcion="Factura"]');
    if (!opcion) return;
    activarOpcion(opcion);
    var campos = { 'factura-rut': 'docRestoreRut', 'factura-razon-social': 'docRestoreRazonSocial', 'factura-giro': 'docRestoreGiro', 'factura-email': 'docRestoreEmail' };
    Object.keys(campos).forEach(function(id) {
      var val = wrapper.dataset[campos[id]];
      if (val) {
        var input = document.getElementById(id);
        if (input) input.value = val;
      }
    });
  }

  /* Restaurar en carga inicial y después de cada SPA navigation */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restaurar);
  } else {
    restaurar();
  }

  /* Observar cambios en el DOM para restaurar tras morph/SPA */
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (node.querySelector && node.querySelector('[data-doc-restore]'))) {
            restaurar();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
